<template>
  <HorizontalFoodCard
      v-for="product in menu.products"
      :key="product.id"
      :product="product"
      @showImg="showFullScreenImage(product.imgurl)"/>

  <!--   Full Screen Image-->
  <transition name="fade">
    <div
        class="fixed flex w-full h-screen top-0 items-center z-20 bg-gray-300 bg-opacity-60 backdrop-filter backdrop-blur-sm"
        v-if="fullScreenImage" @click="fullScreenImage = ''">
      <img :src="fullScreenImage" @error="$event.target.src = require('@/assets/img/placeholder.png')">
    </div>
  </transition>
</template>

<script>
import HorizontalFoodCard from "@/components/HorizontalFoodCard";
import {getSubMenu} from "@/API/API";

export default {
  name: "SubMenu",
  components: {HorizontalFoodCard},
  async created() {
   
    // only call first time we create this page, otherwise we use route watcher
    if (Object.keys(this.menu).length === 0)
      this.menu = (await getSubMenu(this.$route.params.id)).data.result
      console.log(this.menu)
  },
  data() {
    return {
      menu: {},
      fullScreenImage: '',
    }
  },
  methods: {
    showFullScreenImage(img) {
      this.fullScreenImage = img;
      console.log(this.fullScreenImage )
    }
  },
  watch: {
    async '$route'() {
      this.menu = []
      // Check the param so it doesnt send request on leaving the page (route changes on leave)
      if (this.$route.params.id)
        this.menu = (await getSubMenu(this.$route.params.id)).data.result
    }
  },
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>